/**
 * The phone app's words for a Deal's writes (piece 35, *Deals (batch CR6)*;
 * decisions 4410, 4520): what the phone says about a sub-stage, a stage's move,
 * Won, Lost and Reopen, a quick deal's hold, the team, the contacts, a file's
 * release and New Deal that the web does not already say. Spread into the one
 * string lookup beside the earlier batches' words. A word the web already says,
 * such as Mark Lost, Reopen at Intent, Add Team Member, Release or + New Deal,
 * is read from the web's own key and is not repeated here.
 */
export const CRM_DEALS_STRINGS = {
  'mobile.deal.release.target': 'Release to',
  'mobile.deal.unreachable': 'Nothing was changed, because the server did not answer. Check the connection, then try again.',
  'mobile.deal.answerSave': 'Save Answer',
  'mobile.deal.answeredOnWeb': 'Answered on the web, where its own inputs stand.',
  'mobile.deal.confirm.complete': 'The Deal moves on to',
  'mobile.deal.confirm.back': 'The Deal steps back to',
  'mobile.deal.confirm.backKept': 'Nothing on this stage is deleted.',
  'mobile.deal.confirm.won': 'The Deal is marked Won, and its Won stage opens.',
  'mobile.deal.confirm.reopen': 'The Deal reopens at Intent, and its loss stays on record.',
  'mobile.deal.confirm.approve': 'The Quick Deal is approved and stays booked as it is.',
  'mobile.deal.confirm.reject': 'The Deal goes back on the pipeline at Intent.',
  'mobile.deal.lost.competitorOnWeb': 'A competitor is named on the web.',
  'mobile.deal.lost.noReasons': 'No loss reason is set up yet. An administrator adds them on the web, in Settings.',
  'mobile.deal.makePrimary': 'Make Primary',
  'mobile.deal.confirm.endMember': 'This member leaves the Deal Team today, and the row stays as history.',
  'mobile.deal.confirm.endContact': 'This contact leaves the Deal today, and the row stays as history.',
  'mobile.deal.team.shareOnWeb': 'A commission share and a change of role are set on the web.',
  'mobile.deal.confirm.release': 'The file is released to',
  'mobile.deal.new.onTheWeb': 'A Project Deal opens on the pipeline at Intent. Its value is set on the web.',
  'mobile.deal.new.quoteRequired': 'The Expected quote date is required.',
  'mobile.deal.new.dayUnreadable': 'Type the date as a day, such as 2026-10-15.',
  'mobile.deal.new.serviceOnTheWeb': 'The owner follows the site’s or the account’s rule. Emergency, the asset, how and when it came in, the window and the ceiling are set on the web.',
  'mobile.deal.new.partsOnTheWeb': 'A Parts Deal names its parts from the catalog, which the phone cannot pick yet, so start it on the web’s New Deal page.',
  'mobile.deal.new.noSites': 'This account has no open site, and a Service Deal names the site the work is at. Add the site first.',
} as const;
